import authRequest from 'utils/authRequest'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'utils/ErrorMessage'
import adminRequest from 'utils/adminRequest'
import authRequested from '../../utils/authRequested'


export const setUserPreference = data => {
  return {
    type: 'SET_USER_PREFERENCE',
    data,
  }
}

export const getUserPreference = userID => async (dispatch, getState) => {
  try {
    const res = await authRequest.get(`/user/${userID}`)
    dispatch(setUserPreference(res?.data?.data))
    console.log('User data fetched successfully')
  } catch (error) {
    console.log('Error in Getting User data', error)
  }
}

export const SendOtp =
  (id, payLoad, callBack) => async (dispatch, getState) => {
    try {
      const response = await authRequested.post(`/users/${id}/sendotp`, payLoad);

      if(response?.status === 201){
        SuccessMessage('OTP Sent Successfully');
        if (callBack) callBack('success');
        return response?.data?.message === 'Success';
      } else{
        ErrorMessage(response?.data?.message);
      }
    } catch (error) {

      ErrorMessage(error); // Ensure this function is defined elsewhere
      if (callBack) callBack('error', error);
      return false;
    }
  };


export const checkEmailOtp = (id, payLoad) => async (dispatch, getState) => {
  
    try {
      const data = await authRequested.patch(`/users/${id}/email`, payLoad)
      if(data.status === 200){
        SuccessMessage('OTP Verified Successfully')
        return data
      }else{
        ErrorMessage(data?.data?.message)
      }
    
    } catch (error) {
      console.log('incorrect OTP', error)
      return error?.message
      
    }
  
}

export const checkPhoneOtp = (id, payLoad) => async (dispatch, getState) => {
  
    try {
      const data = await authRequest.patch(`/users/${id}/phone`, payLoad)
      SuccessMessage('OTP Verified Successfully')
      console.log('otp verified successfully')
      return data
    } catch (error) {
      console.log('incorrect OTP', error)
      return error?.message
      
    }

}


export const getNotificationCatalogues = (eventId) => async (dispatch, getState) => {
  try {
    const result = await adminRequest.get(
      `notificationCatalogue?pageLimit=10&pageNo=0${eventId}`
    )
    return result?.data?.data
  } catch (error) {
    console.log('Error in getting skills list =>', error)
    ErrorMessage(error?.response?.data?.message)
    return error
  
  }
}

export const sendNotificationEmail =
  (payload,messageStatus) => async (dispatch, getState) => {

    try {
      let res = await authRequest.post(
        `/notification/email`,
        payload
      )
      if (res.status === 200 && messageStatus) {
        SuccessMessage(res.data.message)
      }
    } catch (error) {
      console.log('Error in activate/inactive a student', error)
    }
  }

  export const sendNotificationBulkEmail =
  (payload) => async (dispatch, getState) => {

    try {
      let res = await authRequest.post(
        `/notification/bulkEmail`,
        payload
      )
      if (res.status === 200) {
        SuccessMessage(res.data.message)
      }
    } catch (error) {
      console.log('Error in activate/inactive a student', error)
    }
  } 
  export const sendNotificationBulkEmailWhatsapp =
  payload => async (dispatch, getState) => {
    try {
      await authRequest.post(`/notification/whatsapp`, payload)
    } catch (error) {
      console.log('Error in activate/inactive a student', error)
    }
  }
  export const sendInAppNotification =
  payload => async (dispatch, getState) => {
    try {
      await authRequest.post(`/users/createNotification`, payload)
    } catch (error) {
      console.log('Error in activate/inactive a student', error)
    }
  }
  